import { render, staticRenderFns } from "./Health-Dots.vue?vue&type=template&id=ff3ffd8a&lang=pug"
import script from "./Health-Dots.vue?vue&type=script&lang=ts"
export * from "./Health-Dots.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports